import { render, staticRenderFns } from "./GotMoreQuestions.vue?vue&type=template&id=7c2ffabc&scoped=true&"
import script from "./GotMoreQuestions.vue?vue&type=script&lang=js&"
export * from "./GotMoreQuestions.vue?vue&type=script&lang=js&"
import style0 from "./GotMoreQuestions.vue?vue&type=style&index=0&id=7c2ffabc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2ffabc",
  null
  
)

export default component.exports